import React from "react";
import { useTranslation } from "react-i18next";
import { useDomain } from "../../../utils/domain";
import { useCallToAction } from "../../../utils/useCallToAction";
import { Button } from "../../Atoms/Button";
export var HeaderCTAs = function HeaderCTAs(param) {
  var _param_hideHeader = param.hideHeader,
    hideHeader = _param_hideHeader === void 0 ? false : _param_hideHeader,
    _param_hideCallToActionInHeader = param.hideCallToActionInHeader,
    hideCallToActionInHeader = _param_hideCallToActionInHeader === void 0 ? false : _param_hideCallToActionInHeader,
    fallback = param.fallback,
    _param_variant = param.
    /** theme of the secondary button either light or dark
    * light in the header
    * dark in the sticky header
    */
    variant,
    variant = _param_variant === void 0 ? "light" : _param_variant;
  var t = useTranslation().t;
  var domain = useDomain();
  var secondaryCallToAction = useCallToAction("secondary");
  var primaryCallToAction = useCallToAction("primary");
  var hasAnyCallToAction = (secondaryCallToAction || primaryCallToAction) && !hideCallToActionInHeader && !hideHeader && domain.id === "paraplegie_ch";
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasAnyCallToAction ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row gap-2.5 items-center z-20 shrink-0 "
  }, secondaryCallToAction && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: variant === "light" ? "primary-reverse" : "primary",
    icon: /*#__PURE__*/React.createElement(secondaryCallToAction.icon, {
      "aria-hidden": true
    }),
    href: secondaryCallToAction.url
  }, t("cta.button_type.".concat(secondaryCallToAction.type))), primaryCallToAction && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "monetary",
    icon: /*#__PURE__*/React.createElement(primaryCallToAction.icon, {
      "aria-hidden": true
    }),
    href: primaryCallToAction.url
  }, t("cta.button_type.".concat(primaryCallToAction.type)))) : fallback !== null && fallback !== void 0 ? fallback : null);
};